<template>
  <div class="SpChooseGroup">
    <slot />
  </div>
</template>

<script type="text/ecmascript-6">
// import { reactive, defineComponent } from 'vue'
import { useFormItemProps } from '@/hooks/useForm'
import useModel from '@/hooks/useModel'
import { defineComponent, computed, provide, toRef, watch } from 'vue'
export default defineComponent({
  name: 'SpChooseGroup',

  nameSpace: 'SpChooseGroup',

  components: {
  },

  props: {
    modelValue: {
      type: String,
      default: null
    },

    iconType: {
      type: String,
      default: 'checkbox'
    },

    type: {
      type: String,
      default: 'radio'
    },

    cancelable: {
      type: Boolean,
      default: true
    },

    htmlName: {
      type: String,
      default: ''
    },

    disabled: {
      type: Boolean,
      default: () => null
    },

    ...useFormItemProps()
  },

  emits: ['update:modelValue', 'radio-change'],

  setup (props, ctx) {
    // const update = value => {
    //   ctx.emit('update:modelValue', value)
    // }
    //
    // const genID = (length) => {
    //   return Number(Math.random().toString().substr(3, length) + Date.now()).toString(36)
    // }

    const modelValue = useModel(toRef(props, 'modelValue'), ctx.emit)

    provide('chooseGroup', {
      name: props.name,
      htmlName: props.htmlName,
      modelValue,
      updateModelValue: (nv) => {
        modelValue.value = nv
      },
      iconType: props.iconType,
      type: props.type,
      // serialID: genID(),
      required: props.required,
      cancelable: props.cancelable,
      validateReg: props.validateReg,
      errorMsgFun: props.errorMsgFun,
      disabled: toRef(props, 'disabled')
    })

    watch(() => props.modelValue, val => {
      ctx.emit('radio-change', val || 0)
    })
  }
})
</script>

<style scoped lang="less">
.SpChooseGroup{
}
</style>
